<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('billing')"
      :columns="columns"
      :column_search="true"
      resource_url="/fel/bill/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <billing-modal ref="emitter_modal" @success="refresh" />
  <billing-viewer-modal ref="billing_viewer_modal" />
  <billing-log-modal ref="billing_log_modal" />
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  get,
  post,
  error_message,
  format_date_time,
  format_currency,
  input_alert,
  base64_to_pdf,
} from "@/utils";
import BillingModal from "../billing_modal/Index.vue";
import BillingViewerModal from "../billing_viewer_modal/Index.vue";
import BillingLogModal from "../billing_log_modal/Index.vue";

export default {
  name: "EmittersDatatable",
  components: {
    GenericTable,
    BillingModal,
    BillingViewerModal,
    BillingLogModal,
  },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          searchable: false,
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return v.format_date_time(row.create_date) || "";
          },
        },
        {
          title: v.$t("emitter"),
          searchable: false,
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.emitter.name || "";
          },
        },
        {
          title: v.$t("nit"),
          name: "nit",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.nit || "";
          },
        },
        {
          title: v.$t("name"),
          name: "name",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.name || "";
          },
        },
        {
          title: v.$t("total"),
          name: "total",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_currency(row.total);
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("log"),
                icon: "fa fa-list",
                icon_class: "is-small has-text-info",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  v.$refs.billing_log_modal.show_modal(uuid);
                },
              },
              // {
              //   args: { uuid: row.uuid },
              //   tooltip: v.$t("view"),
              //   icon: "fa fa-eye",
              //   icon_class: "is-small has-text-info",
              //   click: (e) => {
              //     let uuid = e.detail.uuid;
              //     v.$refs.billing_viewer_modal.show_modal(uuid);
              //   },
              // },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("pdf"),
                icon: "fa fa-file-pdf-o",
                icon_class: "is-small has-text-primary",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  get("/fel/bill/pdf", { uuid: uuid })
                    .then((x) => {
                      base64_to_pdf(x, "billing.pdf");
                    })
                    .catch((error) => {
                      error_message(error);
                    });
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("void"),
                icon: "fa fa-ban",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  input_alert({
                    title: v.$t("enter voiding reason"),
                  })
                    .then((void_reason) => {
                      post("/fel/bill/void", {
                        uuid: uuid,
                        void_reason: void_reason,
                      })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    })
                    .catch((e) => {
                      error_message(e);
                    });
                  // confirm_deletion_dialog(
                  //   v.$t("are you sure to void bill?"),
                  //   v,
                  //   () => {}
                  // );
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete bill?"),
                    v,
                    () => {
                      del("/fel/bill", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_date_time,
    format_currency,
    create() {
      let v = this;
      v.$refs.emitter_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
